import { useState } from "react";
import { Product } from "../types/order";

const CustomerCardsWithRejectedToggle = ({ product_list, onCustomerClick }: {
    product_list: Product[],
    onCustomerClick?: (customerId: number) => void
}) => {
    const [openIndexes, setOpenIndexes] = useState<number[]>([]);

    const toggleRejected = (index: number) => {
        setOpenIndexes((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );
    };

    const groupedProducts = product_list?.reduce((acc, product) => {
        const key = product.created_for;
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(product);
        return acc;
    }, {} as Record<number, Product[]>);


    return (
        <div className="grid grid-cols-3 gap-4">
            {Object.entries(groupedProducts || {})?.map(([createdFor, products]) => {
                const customerName = products[0]?.customer_detail?.full_name;

                return (
                    <div
                        key={createdFor}
                        className="bg-[#F9F9F9] p-4 rounded-xl shadow border space-y-2 cursor-pointer"
                        onClick={() => onCustomerClick && onCustomerClick(Number(createdFor))}
                    >
                        <div className="flex justify-between items-center font-medium">
                            {customerName}
                            <a href="#" className="text-blue-500 text-xs">↗</a>
                        </div>
                        <div className="w-full border-[.3px]" />
                        <div className="flex flex-col gap-2">
                            {products.map((item) => (
                                <div key={item.id} className=" p-2 rounded">
                                    <div className="text-[#333333] text-[13px]">{item.name}</div>
                                    <div className="flex items-start gap-2 justify-between w-full">
                                        <div>
                                            {`${item.country_currency_want} ${item.quantity}`}{" "}
                                            <span className="">
                                                <span className="text-blue-700">@</span> <small className="text-gray-500">INR</small> {item?.rate_and_margins?.[0]?.ibr_rate}
                                            </span>
                                        </div>
                                        <div className="bg-[#E4EEFF] text-[#165FE3] px-3 py-0.5 rounded-2xl text-xs font-medium">
                                            {item.status || 'N/A'}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}

        </div>
    );
};
export default CustomerCardsWithRejectedToggle;